import { useAppContext } from '../../../providers';

import { SetupContent } from '../../organisms';
import { SelectPlant } from '../../atoms';

import * as classes from './Setups.module.css';

/**
 * Component for the Setups page.
 */
export const Setups = () => {
  const { selectedPlant } = useAppContext();

  return (
    <div className={classes.container}>
      <div className={classes.plantSelect}>
        <SelectPlant />
      </div>
      {selectedPlant && <SetupContent />}
    </div>
  );
};
